import { useEffect, useState } from "react";
import LayoutWeb from "../LayoutWeb/layoutWeb";
import { getAllWebData } from "../../api/webData.api";
import "./Services.scss";
import ServicesForms from "../../components/ServicesEditForm/ServicesEditForm";

const Services = () => {
  const [webData, setWebData] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchGetAllWebData() {
    setLoading(true);
    try {
      const data = await getAllWebData();
      if (data && data.length > 0) {
        setWebData(data[0]);
      }
    } catch (error) {
      console.error("Error obteniendo los datos de la web:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchGetAllWebData();
  }, []);

  return (
    <LayoutWeb subTitle="Catálogos">
      <div className="CatalogsContent pb-12">
        {/* Usamos renderizado condicional aquí */}
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#666" }}>
            Cargando datos de los servicios...
          </div>
        ) : webData ? (
          <>
            <ServicesForms webData={webData} refreshData={fetchGetAllWebData} />
          </>
        ) : (
          <div style={{ padding: "3rem", textAlign: "center", color: "red" }}>
            No se ha podido cargar la información.
          </div>
        )}
      </div>
    </LayoutWeb>
  );
};

export default Services;
